/**
 * WHITELIST de configuraciones que pueden exponerse publicamente
 *
 * PRINCIPIO: Deny-by-default
 * - Si una key NO esta en esta lista, NUNCA se expone por API publica
 * - Esta lista debe estar en codigo (no en BD) para evitar errores humanos
 */
export const ALLOW_FREE_OYENTE_UNACH_SETTING_KEY = 'ALLOW_FREE_OYENTE_UNACH' as const;

export const PUBLIC_SETTINGS_WHITELIST = [
  'system.maintenance.mode',
  'system.maintenance.message',
  'event.registration.isOpen',
  'event.registration.startDate',
  'event.registration.endDate',
  'REGISTRATION_ATTENDEE_ENABLED',
  'REGISTRATION_SPEAKER_ENABLED',
  'REGISTRATION_ATTENDEE_DEADLINE',
  'REGISTRATION_SPEAKER_DEADLINE',
  'REGISTRATION_ATTENDEE_STATUS',
  'REGISTRATION_SPEAKER_STATUS',
  ALLOW_FREE_OYENTE_UNACH_SETTING_KEY,
  'security.session.timeoutMinutes',
  'ui.support.contactEmail',
  'ui.support.phoneNumber',
  'ui.theme.primaryColor',
] as const;

export type PublicSettingKey = typeof PUBLIC_SETTINGS_WHITELIST[number];

/**
 * Verifica si una key esta en la whitelist publica
 */
export function isPublicSetting(key: string): key is PublicSettingKey {
  return PUBLIC_SETTINGS_WHITELIST.includes(key as PublicSettingKey);
}
